//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('actStatusMenu', {
//        templateUrl: 'views/components/views/actStatusMenu/actStatusMenu.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'actStatusMenuService', function ($stateParams, stateService, actStatusMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let actStatusKeyno = $stateParams.actstatus_keyno;

//			vm.model = {
//                activityStatusNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('actstatuslangs', { actstatus_keyno: vm.model.menu.actstatus_keyno }) }
//                ],
//				menu: {}
//			};

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMenu() {
//                vm.model.menu = (await actStatusMenuService.getMenu({ actstatus_keyno: actStatusKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
